import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {CrudConfig, DatatableViewComponent, RequestParams} from '@ngx-ivengi/crud';
import {BuildingDatatableComponent} from './building-datatable.component';

@Component({
  selector: 'app-building-overview',
  templateUrl: 'building-overview.component.html'
})
export class BuildingOverviewComponent implements OnInit {

  public initialized: boolean = false;
  public requestParams: RequestParams = new RequestParams();
  private nameFilterId = this.crudConfig.getFilterId();
  private addressFilterId = this.crudConfig.getFilterId();
  private zipFilterId = this.crudConfig.getFilterId();
  private cityFilterId = this.crudConfig.getFilterId();
  private countryFilterId = this.crudConfig.getFilterId();

  @ViewChild(BuildingDatatableComponent)
  private dataTable: BuildingDatatableComponent;

  constructor(
    private crudConfig: CrudConfig
  ) {}

  ngOnInit(): void {
    this.initialized = true;
  }

  public filter(event) {
    this.dataTable.requestParams
      .addFilterParam({
        id: this.nameFilterId,
        key: 'name',
        operator: 'eq',
        value: event.target.value || '',
        filterFn: 'substringof',
        filterOutcome: 'true'
      })
      .addFilterParam({
        id: this.addressFilterId,
        key: 'address.address',
        operator: 'eq',
        value: event.target.value || '',
        filterFn: 'substringof',
        filterOutcome: 'true',
        joinOperator: 'or'
      })
      .addFilterParam({
        id: this.zipFilterId,
        key: 'address.zip',
        operator: 'eq',
        value: event.target.value || '',
        filterFn: 'substringof',
        filterOutcome: 'true',
        joinOperator: 'or'
      })
      .addFilterParam({
        id: this.cityFilterId,
        key: 'address.city',
        operator: 'eq',
        value: event.target.value || '',
        filterFn: 'substringof',
        filterOutcome: 'true',
        joinOperator: 'or'
      })
      .addFilterParam({
        id: this.countryFilterId,
        key: 'address.country',
        operator: 'eq',
        value: event.target.value || '',
        filterFn: 'substringof',
        filterOutcome: 'true',
        joinOperator: 'or'
      });

      this.dataTable.filter(event);
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/building/building-overview.component.ts